module.exports = __webpack_public_path__ + "fonts/Nunito-ExtraLightItalic.c878bb8.ttf";